import css from 'styled-jsx/css'

import { colors, sizes, common } from '../../theme'


export default css`
main {
  ${common.page}
}

section {
  position: relative;
  max-width: ${sizes.body.tablet.maxWidth};
  margin: 0 auto;
}

section.method {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 6rem;
  padding: 2rem;
  flex: 1;
  margin-top: 3rem;
  margin-bottom: 3rem;
}

section.method :global(h1 span) {
  margin: 0;
}

section.method :global(aside) {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}

section.method :global(article) {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
}

section.method :global(p) {
  ${common.h3}
  text-align: left;
  color: ${colors.pureWhite};
  max-width: 83rem;
  margin-top: 4rem;
}

section.method :global(.team-box p) {
  font-family: 'Nexa Regular', sans-serif;
  ${common.small}
  line-height: 1.6;
  color: ${colors.yellow};
  margin-top: 0;
}

section.method :global(.team-article) {
  align-self: flex-end;
}

section.method :global(.team-box .uptitle) {
  margin-bottom: 1rem;
}

.tag-content {
  font-family: 'Nexa Bold', serif;
  font-size: 1.8rem;
  line-height: 2.7rem;
  text-transform: uppercase;
  color: ${colors.yellow};
  margin-bottom: 0.5rem;
}

section.team :global(.cloud) {
  position: absolute;
  left: 10%;
  user-select: none;
}

section.team {
  background-color: ${colors.midnightExpress};
}

section.team :global(h1) {
  opacity: unset;
  line-height: unset;
  padding: 0;
}

section.team :global(h1 + p) {
  text-align: right;
}

section.team :global(.team-box) {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: flex-end;
}

section.team :global(.pictures) {
  margin-top: 5rem;
}

section.team :global(.pictures) {
  width: 100%;
  margin-top: 5rem;
}


section.team :global(.masonry-grid) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: -3rem; /* gutter size offset */
  width: auto;
}
section.team :global(.masonry-grid_column) {
  padding-left: 3rem; /* gutter size */
  background-clip: padding-box;
}


section.team :global(.masonry-grid_column > div) {
  background-color: gray;
  margin-bottom: 3rem;
}

section.team :global(p) {
  font-family: 'Nexa Bold', serif;
  font-size: 1.8rem;
  line-height: 27.29px;
  text-align: left;
  color: ${colors.pureWhite};
  max-width: 70rem;
  text-transform: uppercase;
}

section.team :global(.persons) {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3rem;
  max-width: 100rem;
  padding-top: 5rem;
  flex-wrap: wrap;
}

section.team :global(.scroll-arrow) {
  display: none;
  position: absolute;
  top: 50%;
  right: 5rem;
  background-color: ${colors.pureWhite};
  box-shadow: 1px 0 5px -2px #666;
  border-radius: 50% 50%;
  height: 8rem;
  width: 8rem;
  align-items: center;
  justify-content: center;
}

section.team :global(.scroll-arrow.hidden) {
  display: none !important;
  cursor: pointer;
}

@media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
  section.method {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  section.method :global(p) {
    ${common.h4}
  }

  main { min-width: 30rem; }

  section.team :global(p) {
    font-size: 1.4rem;
  }

  section.clients :global(.clients-list) {
    flex-wrap: wrap;
    margin-top: 1rem;
  }

  section.clients {
    padding-top: 1rem;
    padding-bottom: 3rem;
  }

  section.method {
    margin-top: 0;
    margin-left: 0;
    margin-bottom: 0;
    padding: 0 1.5rem;
  }

  section.method :global(p) {
    font-size: 2.5rem;
    margin-top: 2rem;
  }

  section.method :global(aside) {
    display: none;
  }

  section.method :global(.method-illus) {
    display: none;
  }

  section.method :global(.method-illus-mobile) {
    display: block;
    width: 100%;
    margin-top: 2rem;
    max-width: 40rem;
  }

  section.team :global(.cloud) {
    position: absolute;
    width: 100%;
    left: 0;
    pointer-events: none;
  }

  section.team :global(.cloud img) {
    width: 100%;
  }

  section.team {
    display: block;
    padding: 1.2rem;
  }

  section.team :global(.team-box) {
    margin-right: 0;
  }

  section.team :global(.persons) {
    padding: 0;
    padding-top: 3rem;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    margin: 0 auto;
  }

  section.team :global(.scroll-arrow) {
    display: flex;
  }

  section.team :global(.masonry-grid) {
    margin-left: -1.5rem; /* gutter size offset */
  }
  section.team :global(.masonry-grid_column) {
    padding-left: 1.5rem; /* gutter size */
  }

  section.team :global(.masonry-grid_column > div) {
    margin-bottom: 1.5rem;
  }
}

@media screen and (max-width: ${sizes.media.mobile.maxWidth}) {
  section.team :global(.persons) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.2rem;
  }

  section.team :global(.persons > div:nth-child(2n + 2)) {
    top: 3rem;
  }
}
`
